<template>
    <span>
        <criarcomunicado></criarcomunicado>
    </span>
</template>

<script>
import Criarcomunicado from '@/components/Criar-Comunicado';

export default {
    name: 'cadcriarcomunicado',
    components: {
        Criarcomunicado
    }
};
</script>